import { SET_AUTHENTICATED_USER, THIRD_PARTY_AUTH_CONTEXT, THIRD_PARTY_AUTH_CONTEXT_CLEAR_ERROR_MSG, SET_REDIRECT_TARGET, CLEAR_REDIRECT_TARGET } from './actions';
import { COMPLETE_STATE, FAILURE_STATE, PENDING_STATE } from '../../data/constants';

export const defaultState = {
  authenticatedUser: {
    userId: 0,
    email: '',
    name: '',
    username: '',
    roles: [],
    administrator: false,
  },
  fieldDescriptions: {
    fields: {},
  },
  optionalFields: {
    fields: {},
    extended_profile: [],
  },
  thirdPartyAuthApiStatus: null,
  thirdPartyAuthContext: {
    autoSubmitRegForm: false,
    currentProvider: null,
    finishAuthUrl: null,
    countryCode: null,
    providers: [],
    secondaryProviders: [],
    pipelineUserDetails: null,
    errorMessage: null,
    welcomePageRedirectUrl: null,
  },
  redirectTarget: null,
};

const reducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case SET_AUTHENTICATED_USER:
      return {
        ...state,
        authenticatedUser: action.payload.user && action.payload.user,
      };
    case THIRD_PARTY_AUTH_CONTEXT.BEGIN:
      return {
        ...state,
        thirdPartyAuthApiStatus: PENDING_STATE,
      };
    case THIRD_PARTY_AUTH_CONTEXT.SUCCESS: {
      return {
        ...state,
        fieldDescriptions: action.payload.fieldDescriptions.fields,
        optionalFields: action.payload.optionalFields,
        thirdPartyAuthContext: action.payload.thirdPartyAuthContext,
        thirdPartyAuthApiStatus: COMPLETE_STATE,
      };
    }
    case THIRD_PARTY_AUTH_CONTEXT.FAILURE:
      return {
        ...state,
        thirdPartyAuthApiStatus: FAILURE_STATE,
        thirdPartyAuthContext: {
          ...state.thirdPartyAuthContext,
          errorMessage: null,
        },
      };
    case THIRD_PARTY_AUTH_CONTEXT_CLEAR_ERROR_MSG:
      return {
        ...state,
        thirdPartyAuthApiStatus: PENDING_STATE,
        thirdPartyAuthContext: {
          ...state.thirdPartyAuthContext,
          errorMessage: null,
        },
      };
    case SET_REDIRECT_TARGET:
      return { ...state, redirectTarget: action.payload };
    case CLEAR_REDIRECT_TARGET:
      return { ...state, redirectTarget: null };
    default:
      return state;
  }
};

export default reducer;
